<template>
<div>
<div class="mpart1">
  <div class="mpart1-1">
    <div class="mpart1-1Title">

        <img src="../assets/img/metalcons.png" alt="">
        <h1 class="mpart1Title">Металлоконструкции</h1>
    </div>
    <p class="mpart1p">«METALIX» предоставляет полный спектор услуг - от проектирования и производства <br> металлоконструкций до доставки на объекты и монтажа.</p>
  </div>    
</div>
<div class="mpart2">
    <div class="mpart2-0">
        <div class="mpart5left">Производство</div>
        <div class="mpart5leftLine"></div>
    </div>
    <div class="mpart2-1">
        <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt="">
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> В сварочно-штамповочном цехе фирмы «METALIX» <br> изготавливаются строительные металлические конструкции по <br>чертежам заказчика, а также собственной разработки. </p>   
    </div>
    <div class="mpart2-2">
        <img src="../assets/img/image145.png" alt="">
    </div>
    <div class="mpart2-3">
        <img src="../assets/img/image142.png" alt="">
    </div>
    <div class="mpart2-4">
        <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt="">
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> В сварочно-штамповочном цехе фирмы «METALIX» <br> изготавливаются строительные металлические конструкции по <br>чертежам заказчика, а также собственной разработки. </p>   

    </div>
     <div class="mpart2-5">
        <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt="">
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> В сварочно-штамповочном цехе фирмы «METALIX» <br> изготавливаются строительные металлические конструкции по <br>чертежам заказчика, а также собственной разработки. </p>   
    </div>
    <div class="mpart2-6">
        <img src="../assets/img/image145.png" alt="">
    </div>
    <div class="mpart2-7">
        <img src="../assets/img/image142.png" alt="">
    </div>
    <div class="mpart2-8">
        <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt="">
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> В сварочно-штамповочном цехе фирмы «METALIX» <br> изготавливаются строительные металлические конструкции по <br>чертежам заказчика, а также собственной разработки. </p>   

    </div>
    
</div>
<div class="part14">
  <div class="part14-8">
    <div class="part14Line"></div>
  </div>
  <div class="part14-0">
        <div class="mpart5left">Преимущества</div>
        <div class="mpart5leftLine"></div>
  </div>
  <div class="part14-1">
    <img src="../assets/img/metacons/part14-1.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Надежность</h1>
      <p class="part14p">в целях создания изотропного материала были <br> применены способы, которые наделяют металл <br> максимальным уровнем сопротивления.</p>
    </div>
  </div>
  <div class="part14-2">
      <img src="../assets/img/metacons/part14-2.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Малый вес конструкций</h1>
      <p class="part14p">Сочетание легкости и прочности, можно сказать, что в  этом и состоит уникальность металлоконструций.</p>
    </div>
  </div>
  <div class="part14-3">
     <img src="../assets/img/metacons/part14-3.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Непроницаемость</h1>
      <p class="part14p">Такой материал, как металл, является абсолютно <br>непроницаемым ни для газов, ни для воды.</p>
    </div>
  </div>
  <div class="part14-4">
    <img src="../assets/img/metacons/part14-4.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Индустриальность</h1>
      <p class="part14p">
        Металлоконструкции производят в заводских усолвия,<br> где для этого присудствует все необходимое <br>современное оборудование и инструменты
      </p>
    </div>
  </div>
  <div class="part14-5">
    <img src="../assets/img/metacons/part14-5.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Простота в ремонте </h1>
      <p class="part14p">
        Конструкции из металла соверешенно несложно<br> усиливать, придавать им повышенную плотность либо <br>накладыват заплаты на участки подвергшиеся<br> разрушению.
      </p>
    </div>
  </div>
  <div class="part14-6">
    <img src="../assets/img/metacons/part14-6.png" width="104px" height="96px" alt="">
    <div style="margin-left:48px">
      <h1 class="part14h1">Скорость монтажа</h1>
      <p class="part14p">
        Одним из главных преимуществ, которое невозможно <br> переоценить, является беспрецедентня скорость<br> монтажа конструкции.
      </p>
    </div>
  </div>
  
  
</div>
<div class="part15">
  <div class="part15-0">
    <div class="part15Line"></div>
  </div>
  <div class="part15-1">
    <h1 class="part15h1">
    Главный принцип в работе заключается в предоставлении<br> максимально удобного и комфортного обслуживания<br> каждому клиенту, поставке только качественных<br> материалов по выгодным ценам.
  </h1>
  </div>
</div>
<div class="mpart8">
      <div class="mpart8-1">
        <div class="mpartInfoT">Проекты</div>
        <span class="mpart8InfoLine"></span>
      </div>
      <div class="mpart8-0">
        <div class="mpart8Line"></div>
      </div>
      <div class="mpart8-2">
        <h1 class="mpart8Title">
          Эффективные технологии и опыт специалистов позволяет <br />
          «METALIX» длостигать безупречного результата в сроки.
        </h1>
      </div>
      <div class="mpart8-3">
        <img class="mpart8Margin" src="../assets/Left.svg" alt="" />
      </div>

      <div class="mpart8-4">
        <img class="mpart8Margin" src="../assets/Right.svg" alt="" />
      </div>
      <div class="mpart8-5">
        <div >
          <carousel
            id="part8carousel" 
            :per-page="1"
            :navigationEnabled="true"
            :paginationEnabled="false"
           
            :mouse-drag="false"
          >
            <slide>
              <img
                class="carouselImg"
                width="100%"
                height="auto"
                src="../assets/img/metal22.png"
                alt=""
              />
            </slide>
            <slide>
              <img
                class="carouselImg"
                width="100%"
                height="auto"
                src="../assets/img/metal22.png"
                alt=""
            /></slide>
          </carousel>
          <!-- <img
            class="carouselImg"
            width="100%"
            height="auto"
            src="../assets/image35.jpg"
            alt=""
          />
          <div class="mainTitle">
            Проектирование,<br />
            изготовление, продажа и монтаж металлоконструкций
          </div>
           -->
        </div>
        <!-- <img width="100%" src="../assets/img/Frame59.png" alt="" /> -->
      </div>
    </div>
  

    <div class="mpart12" style="margin-top:300px">
      <div class="mpart12-0">
        <div class="mpart12-0Line"></div>
      </div>
      <div class="mpart12-1">
        <div class="mpart12-1Line"></div>
      </div>
      <div class="mpart12-2">
        <h4 class="mpart12-2Info">Обратная связь</h4>
        <div class="mpart12-2InfoLine"></div>
      </div>
      <div class="mpart12-3">
        <h1 class="mpart12-3T">
          Заполните форму обратной <br />
          связи и мы оперативно<br />
          свяжемся с вами !
        </h1>
      </div>
      <div class="mpart12-4">
       <b-form @submit="onSubmit" v-if="show" class="row" action="../../public/test.php"  method="POST">
      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="name"
          id="input-1"
          v-model="name"
          type="name"
          placeholder="Ваша имя"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="surname"
          id="input-2"
          v-model="surname"
          type="surname"
          placeholder="Ваша фамилия"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="email"
          id="input-3"
          v-model="email"
          type="email"
          placeholder="Ваша почта"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="phone"
          id="input-4"
          v-model="phone"
          type="phone"
          placeholder="Ваш номер"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group  class="form-metalix">
        <b-form-input class="form-metalix-1" label="message"
          id="input-5"
          v-model="message"
          type="message"
          placeholder="Комментария"
          
        ></b-form-input>
      </b-form-group>
        <div style="display: flex; width:50%;">
          <input type="checkbox" checked  style="width:30px; height:50px; margin-right:3rem;">
          <p style="color:white;"> Я согласен на обработку<br/>персональных данных.  </p>
         
        </div>

      <b-button data-submit="...Sending" @click="showAlert" class="col-md-6 form-metalix-1 sending-btn" type="submit"  variant="primary">Отправить заявку</b-button>
    </b-form>
      </div>
      <div class="mpart12-5">
        <div class="mpart12TitleLine"></div>
        <p class="mpart12Tp">
          В разделе “комментарий” вы можете указать удобное для вас время когда
          мы можем с вами связаться.
        </p>
      </div>
      <div class="mpart12-6">
        <p class="mpart12Tp2">
          Мы не занимаемся рассылкой рекламных сообщений, а также не передаем
          контактные данные третьим лицам !
        </p>
      </div>
    </div>
    <div class="mpart13">
      <div class="mpart13-0">
        <h4 class="mpart13-0T">Контакты</h4>
        <div class="mpart13-0L"></div>
      </div>
      <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div>
      <div class="mpart13-2">
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный <br />интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div style="display: flex; margin-top: 84px">
          <img src="../assets/img/location.svg" alt="" />
          <ul class="mpart13-4Address">
            <li>г.Ташкент, Сергели</li>
            <li>ул.Нилуфар 77/7, 100155</li>
          </ul>
        </div>
        <div style="display: flex">
          <img src="../assets/img/phone.svg" alt="" />
          <ul class="mpart13-4PhoneUl">
             <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
          </ul>
        </div>
        <div style="display: flex; margin-top: 40px">
          <img src="../assets/img/mail.svg" alt="" />
          <p class="mpart13-4mailp">info@metalix.uz</p>
        </div>
        <div>
          <ul class="mpart13-4PhoneUl2">
            <li>По вопросам партнерства</li>
            <li>+998  90 334 35 00</li>
            <li>info@metalix.uz</li>
          </ul>
        </div>
        <div style="display: flex">
          <img class="mpart13icon" src="../assets/img/tgb.svg" alt="" />
          <p class="mpart13-4mailp2">Telegram</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/fbb.svg" alt="" />
          <p class="mpart13-4mailp2">Facebook</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/Inb.svg" alt="" />
          <p class="mpart13-4mailp2">Instagram</p>
        </div>
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
              <iframe 
            class="gmap_iframe"
             
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.6581975340723!2d69.25022158783936!3d41.20638627079112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x702a9595707bb6f!2zNDHCsDEyJzIyLjkiTiA2OcKwMTUnMDguNyJF!5e0!3m2!1sru!2s!4v1636694271660!5m2!1sru!2s" width="100%" height="886" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>
      </div>
    </div>
   
</div>
</template>
<script>
import Swal from "sweetalert2";
import { directive } from "vue-awesome-swiper";
import axios from 'axios';
import "swiper/swiper-bundle.css";
export default {
  data() {
      return {
        form: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        },
        // foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        let data = new FormData(); 
    
 
    data.append('name', this.name) 
    data.append('surname', this.surname) 
    data.append('email', this.email) 
    data.append('phone', this.phone) 
    data.append('message', this.message)
    console.log(data)
        axios.post('../../public/test.php', data)

    .then((data) => {Swal.fire({
  position: 'center',
  icon: 'success',
  iconColor: 'red',
  title: 'Отправлено !',
  showConfirmButton: false,
  timer: 1500
});console.log(data)})
    .catch(error => {

       
        console.error('There was an error!', error);
        this.$swal('Error');
    });
      },
      


      showAlert(){
			
  
 
  
			
		},
    },
   components: {
    // VueSlickCarousel,
    // Carousel, Slide
   
  },
  directives: {
    swiper: directive,
  }, 
      mounted () {
  window.scrollTo(0, 0)
}


}
</script>
<style>
.mpart1{
   display: grid;
  grid-template-columns: 232px 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1-1Title{
    display: flex;
    justify-content: left;
    margin-top: 96px;
}
.mpart1Title{
height: 88px;
font-family: Inter;
font-style: normal;
font-weight: bold;
font-size: 64px;
line-height: 88px;
/* identical to box height, or 137% */
margin-left: 64px;
letter-spacing: 0.015em;
text-transform: uppercase;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart1p{
    height: 80px;
    margin-top: 40px;
    margin-bottom: 192px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 40px;
/* or 167% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.form-metalix {
  margin-bottom: 5rem;
}
.form-metalix-1{
  height: 80px;
}
.sending-btn{
  width: 400px;
  margin-left: 15px !important;
  background-color: white;
  border: none;
  font-family: Styrene A LC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #272a2e;
}
.mpart8Line {
  width: 120px;
  height: 1px;

  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.mpart8Margin {
  margin-bottom: 40px;
  margin-top: 40px;
}
.mpart8Title {
  width: 80%;
  height: 96px;
  margin-bottom: 104px;
  margin-left: 32px;
  margin-right: 32px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.mpart2
{
    display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart2-1 {
  grid-column: 2/4;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 5/7;
  grid-row: 1/2;
}
.mpart2-3 {
  grid-column: 2/4;
  grid-row: 2/3;
  margin-top: 32px;
}
.mpart2-4 {
  grid-column: 5/7;
  grid-row: 2/3;
  text-align: left;
  margin-top: 32px;
}
.mpart2-5 {
  grid-column: 2/4;
  grid-row: 3/3;

}
.mpart2-6 {
  grid-column: 5/7;
  grid-row: 3/3;
}
.mpart2-7 {
  grid-column: 2/4;
  grid-row: 4/4;
  margin-top: 32px;
}
.mpart2-8 {
  grid-column: 5/7;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}
.mpart2-9 {
  grid-column: 4/8;
  grid-row: 5/5;

}
.mpart2-1Line{
    width: 760px;
height: 1px;
margin-top: 64px;
/* line (darck) */
margin-bottom: 39px;
background: #B4C0CF;
}
.mpart2-1p{
    width: 696px;
    height: 120px;
text-align: left;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 40px;
/* or 222% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart5leftLine {
  width: 164px;
  height: 2px;
  margin-top: 180px;
  margin-left: 18px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart5left {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

/************part8  ****************/

.mpart8 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart8-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart8-1 {
  grid-column: 1/2;
  grid-row: 3/4;
  display: block;
}

.mpart8-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.mpart8-3 {
  grid-column: 4/5;
  grid-row: 2/2;
}

.mpart8-4 {
  grid-column: 5/6;
  grid-row: 2/2;
}

.mpart8-5 {
  grid-column: 2/6;
  grid-row: 3/4;
}
.mpart8InfoLine {
  width: 164px;
  height: 2px;
  right: -151px;
  bottom: -2px;

  /* metalix (ligtt,text) */

  background: #36454f;
  transform: rotate(-90deg);
}
.mpartInfoT {
  width: 78px;
  height: 24px;

  margin-top: 150px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
#part8carousel .VueCarousel-navigation-next{
    
    z-index: 4 !important;
    margin-right: 135px !important;
    margin-top: -530px !important;
}
#part8carousel .VueCarousel-navigation-prev{
   
    margin-top: -530px !important;
    margin-left: 1365px !important;
    z-index: 4 !important;
}
/***********part 8 end */
/**************part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart12-1 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.mpart12-2 {
  grid-column: 1/2;
  grid-row: 1/7;
}
.mpart12-3 {
  grid-column: 2/4;
  grid-row: 2/3;
}
.mpart12-4 {
  grid-column: 5/5;
  grid-row: 2/5;
}
.mpart12-5 {
  grid-column: 2/4;
  grid-row: 3/4;
}
.mpart12-6 {
  grid-column: 2/4;
  grid-row: 4/6;
}
.mpart12TitleLine {
  width: 392px;
  height: 4px;
  margin-top: 96px;
  margin-bottom: 76px;
  /* _Light */

  background: #fbfbfb;
}
.mpart12Tp {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Tp2 {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-top: 72px;
  margin-bottom: 104px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12-0Line {
  width: 120px;
  height: 2px;
  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
}
.mpart12-1Line {
  width: 880px;
  height: 2px;

  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12-2Info {
  margin-top: 300px;
  width: 247px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.mpart12-2InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 190px;
  margin-left: 43px;
  background: #4b5a64;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart12-3T {
  width: 543px;
  height: 144px;
  margin-top: 0;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Checkp {
  width: 310px;
  height: 48px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  margin-left: 50px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
#mpart12Check {
  width: 32px;
  height: 32px;
  background-color: #36454f !important;
  /* Light (darck) 02 */

  border: 1px solid #9dafbc;
  box-sizing: border-box;
  border-radius: 1.5px;
}
.mpart12InfoBT {
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* Metalix_darck */

  color: #272a2e;
}
.mpart12InfoLine {
  width: 880px;
  height: 1px;
  margin-bottom: 63px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12InfoMust {
  width: 532px;
  height: 24px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-top: 40px;
  margin-bottom: 104px;
  margin-left: 15px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12InfoButton {
  width: 392px;
  height: 80px;

  background: #cfd3d6;
  box-shadow: 0px 4px 32px #575d65;
}

.mpart12Infotextarea {
  background: #fbfbfb;
  /* _Light */
  margin-top: 48px;
  margin-left: 105px;
  width: 800px;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
#fname {
  width: 392px;
  height: 64px;

  /* _Light */

  background: #fbfbfb;
  /* _Light */

  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
/****************part12 end*/
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart13-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart13-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.mpart13-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.mpart13-5 {
  grid-column: 4/8;
  grid-row: 3/3;
}
.mpart13-4Line {
  width: 392px;
  height: 4px;

  /* _Text */

  background: #233b57;
}
.mpart13icon {
  margin-top: -15px;
}
.mpart13-4Address {
  width: 336px;
  height: 48px;
  margin-top: 35px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl2 {
  width: 336px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-left: 28px;
  list-style-type: none;
  letter-spacing: 0.15em;
  margin-bottom: 105px;
  margin-top: 88px;
  /* active(bottom) */

  color: #d19258;
}
.mpart13-4mailp2 {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  margin-left: 28px;
  /* margin-top: 15px; */
  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4mailp {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  letter-spacing: 0.15em;
  margin-left: 30px;
  /* Text */

  margin-top: 14px;
  color: #233b57;
}
.mpart13-4PhoneUl {
  width: 336px;
  height: 72px;
  margin-top: 60px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-0T {
  width: 89px;
  height: 24px;
  margin-top: 15px;
  margin-left: 36px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */

  color: #233b57;

  transform: rotate(-90deg);
}
.mpart13-0L {
  width: 164px;
  height: 2px;
  margin-top: 150px;
  /* margin-bottom: 400px; */
  /* _Text */

  background: #233b57;
  transform: rotate(-90deg);
}
.mpart13-1Line {
  width: 120px;
  height: 1px;
  margin-top: 108px;
  margin-bottom: 99px;

  background: #b4c0cf;
}
.mpart13T {
  width: 715px;
  height: 96px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  margin-bottom: 96px;
  /* Text */

  text-align: left;
  color: #233b57;
}
.mpart13Tp {
  width: 696px;
  height: 80px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* Text */

  color: #233b57;
}
/***********part 13 end */
/******part 14 *****/
.part14 {
  display: grid;
  grid-template-columns: 200px 1fr 0.5fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.part14-1 {
  grid-column: 2/3;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 4/5;
  grid-row: 2/2;
    display: flex;
}
.part14-3 {
  grid-column: 2/3;
  grid-row: 3/3;
    display: flex;
}
.part14-4 {
  grid-column: 4/5;
  grid-row: 3/3;
    display: flex;
}
.part14-5 {
  grid-column: 2/3;
  grid-row: 4/4;
    display: flex;
}

.part14-6 {
  grid-column: 4/5;
  grid-row: 4/4;
    display: flex;
}
.part14-8 {
  grid-column: 2/5;
  grid-row: 1/2;
}
.part14Line{
width: 1672px;
height: 1px;
left: 200px;
top: 3600px;
margin-bottom:127px ;
margin-top: 96px;
/* line (darck) */

background: #B4C0CF;
}
.part14h1{
width: 100%;
height: 32px;
left: 176px;
top: 8px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 32px;
/* identical to box height, or 133% */

letter-spacing: 0.1em;

/* metalix (ligtt,text) */

color: #36454F;
}
.part14p{
  margin-top: 40px;
  margin-bottom: 112px;
  width: 544px;
height: 96px;
left: 176px;
top: 80px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 32px;
/* or 200% */

letter-spacing: 0.1em;
text-indent: 24px;

/* metalix (ligtt,text) */

color: #36454F;
}
/******part 14 end */
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 200px 1fr ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  grid-column: 1/2;
  grid-row: 1/2;
}

.part15-1{
  grid-column: 2/3;
  grid-row: 1/2;
}
.part15Line{
  width: 384px;
height: 2px;
margin-top: 287px;
    margin-left: -95px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 150px;
  width: 1152px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
/****part15 end*/
</style>